/**
 * True only for the Netlify staging frontend hostname.
 * Used to align staging teacher UX with production (e.g. no Student Check-Ins dashboard).
 */
export const isStagingWebApp = (): boolean => {
  if (typeof window === 'undefined') return false;
  return window.location.hostname === 'traffic-lite-front-end-staging.netlify.app';
};

/**
 * Production marketing / prod Netlify hosts (existing App.tsx checks).
 */
export const isProductionWebApp = (): boolean => {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname.toLowerCase();
  return (
    host === 'traffic-lite-production.netlify.app' ||
    host === 'trafficliteedu.com' ||
    host === 'www.trafficliteedu.com'
  );
};

/** All web builds route teachers to Policy Details (Student Check-Ins dashboard removed). */
export const shouldRedirectTeacherDashboardToPolicy = (): boolean => true;
